import { SET_ACTIVE_MODULE } from './constants'

export function setActiveModule(module, noRouter = false) {
    return {
        type: SET_ACTIVE_MODULE,
        data: {
            module,
            noRouter,
        },
    }
}
